module.exports = __webpack_public_path__ + "static/img/student_head.8f17a148.png";